// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__rY3Yt","inputWrap":"styles_inputWrap__31Qjn","input":"styles_input__1aja3"};